(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
angular.module('accountrequest', ['dablecommon']).controller('AccountRequestCtrl', ['$scope', '$http', '$window', '$i18next', 'keyMirror', function ($scope, $http, $window, $i18next, keyMirror) {
  var syncHeight = $window.syncHeight;
  var INFLOW_TYPES = _.map($window.INFLOW_TYPE_MAP, function (v) {
    return v;
  });
  var MESSAGE_TYPE = {
    ALERT: 'alertMessage',
    SUBMIT_FORM: 'accountRequestSubmit'
  };
  var CAMPAIGN_TYPES = {
    TYPE1: '정책홍보, 비영리단체, 문학 및 공연 등',
    TYPE2: '쇼핑, 교육, 엔터테인먼트, 게임, IT, 여행, 소비재, 생활 정보 등',
    TYPE3: '병의원, 금융, 부동산, 건강식품 (보조재, 의약외품 등) 등',
    TYPE_ETC: '기타'
  };
  var sendMessageToParentWindow = function sendMessageToParentWindow(type, message) {
    if (type === MESSAGE_TYPE.ALERT && $window.parent === $window)
      // URL에 직접 접근하는 테스트 목적 등의 경우
      $window.alert(message.text);else $window.parent.postMessage(JSON.stringify({
      type: type,
      message: message
    }), '*');
  };
  var init = function init() {
    $scope.payload = {
      business_location: '',
      business_location_etc: '',
      type: '',
      name: '',
      email: '',
      pwd: '',
      phone: '',
      known_route: '',
      biz_name: '',
      biz_url: '',
      certification: '',
      product_license: '',
      sample_url: '',
      campaign_country: '',
      campaign_type: '',
      budget_info: '',
      campaign_info: '',
      message: '',
      tip: 'false',
      is_agree: 1
    };
    // 비밀번호 유효성 검사 상태
    $scope.passwordValidation = {
      store: '',
      isLengthValid: false,
      isComplexityValid: false,
      error: null
    };
    $scope.emailValidation = {
      store: '',
      error: null
    };
    angular.element('#input_file').val(null);
  };
  var executeMSNConversionScript = function executeMSNConversionScript(lang) {
    if (lang !== 'en') return;
    // eslint-disable-next-line no-console
    console.log('msn starts');
    var scriptEl = $window.document.createElement('script');
    scriptEl.type = 'text/javascript';
    scriptEl.innerHTML = "(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:\"148022346\"};o.q=w[u],w[u]=new UET(o),w[u].push(\"pageLoad\")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!==\"loaded\"&&s!==\"complete\"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,\"script\",\"//bat.bing.com/bat.js\",\"uetq\");";
    var bodyEl = $window.document.querySelector('body');
    bodyEl.appendChild(scriptEl);
    var script = $window.document.getElementsByTagName('script');

    // eslint-disable-next-line no-eval
    eval(script[script.length - 1].innerHTML);
    // eslint-disable-next-line no-console
    console.log('msn finished');
  };
  var handleRequestError = function handleRequestError(err) {
    var code = err.code,
      message = err.message;
    if (!code) {
      var _err$data, _err$data2;
      code = err === null || err === void 0 || (_err$data = err.data) === null || _err$data === void 0 ? void 0 : _err$data.code;
      message = err === null || err === void 0 || (_err$data2 = err.data) === null || _err$data2 === void 0 ? void 0 : _err$data2.message;
    }
    if (!code) {
      if (message) {
        return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
          type: 'error',
          title: '',
          text: message,
          animation: false
        });
      } else {
        return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
          type: 'error',
          title: '',
          text: $i18next.t('account_request::계정 생성 요청이 실패하였습니다.'),
          animation: false
        });
      }
    }
    var text = '';
    var validationTarget = null;
    switch (code) {
      case 'INVALID_EMAIL_FORMAT':
        text = $i18next.t('account_request::이메일 주소 형식이 올바르지 않습니다. 다시 확인해 주세요.');
        validationTarget = $scope.emailValidation;
        break;
      case 'DUPLICATED_EMAIL':
        text = $i18next.t('account_request::이미 사용중인 이메일 입니다.');
        validationTarget = $scope.emailValidation;
        break;
      case 'INVALID_PASSWORD_COMPLEXITY':
        text = $i18next.t('account_request::영문, 숫자, 특수문자를 조합하여 8자리 이상을 입력해 주세요.');
        validationTarget = $scope.passwordValidation;
        break;
      case 'INVALID_PASSWORD_INCLUDES_EMAIL':
        text = $i18next.t('account_request::이메일에 있는 단어는 비밀번호에 사용할 수 없습니다.');
        validationTarget = $scope.passwordValidation;
        break;
      default:
        text = $i18next.t('account_request::계정 생성 요청이 실패하였습니다.');
        return;
    }
    if (validationTarget) {
      setTimeout(function () {
        validationTarget.error = text;
        $scope.$apply();
      }, 0);
    }
    return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
      type: 'info',
      title: '',
      text: text,
      animation: false
    });
  };
  var submit = function submit() {
    var payload = $scope.payload;
    var PROTOCOL_REGEX = new RegExp('(http)s?://');
    if (payload.biz_url !== '' && !PROTOCOL_REGEX.test(payload.biz_url)) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::회사 웹사이트 주소를 기입하실때에는 프로토콜(http:// 또는 https://)도 같이 입력해 주세요.'),
        animation: false
      });
    }
    if (payload.sample_url !== '' && !PROTOCOL_REGEX.test(payload.sample_url)) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::샘플 콘텐츠 주소를 기입하실때에는 프로토콜(http:// 또는 https://)도 같이 입력해 주세요.'),
        animation: false
      });
    }
    if (['client', 'agency'].indexOf(payload.type) === -1) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::타입을 설정해 주세요.'),
        animation: false
      });
    }
    if (payload.business_location.length === 0) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::사업자 소재지를 선택해 주세요.'),
        animation: false
      });
    }
    if (payload.business_location === 'ETC' && payload.business_location_etc.length === 0) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::사업자 소재지를 입력해 주세요.'),
        animation: false
      });
    }
    if (payload.name.length === 0) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::이름을 입력해 주세요.'),
        animation: false
      });
    }
    if (payload.email.length === 0) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::이메일을 입력해 주세요.'),
        animation: false
      });
    }
    if (payload.pwd.length === 0) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::비밀번호를 입력해 주세요.'),
        animation: false
      });
    }
    if (payload.phone.length === 0) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::전화번호를 입력해 주세요.'),
        animation: false
      });
    }
    if (payload.known_route === '') {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::데이블을 알게된 경로를 입력해 주세요.'),
        animation: false
      });
    }
    if (payload.biz_name.length === 0) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::회사명을 입력해 주세요.'),
        animation: false
      });
    }
    var CHECK_CERTIFICATION_PAYLOAD_COUNTRY = ['KR', 'ID', 'TW', 'VN'];
    if (CHECK_CERTIFICATION_PAYLOAD_COUNTRY.indexOf(payload.business_location) > -1 && payload.certification.length === 0) {
      var text = '';
      switch (payload.business_location) {
        case 'TW':
          text = $i18next.t('account_request::8자리 납세자 번호를 입력해 주세요.');
          break;
        case 'ID':
          text = $i18next.t('account_request::사업자 등록증 또는 NPWP를 업로드해 주세요. jpeg, jpg, gif, png, pdf 파일만 가능하며 5MB이하의 파일만 업로드 가능합니다.');
          break;
        case 'VN':
          text = $i18next.t('account_request::사업자 등록증을 업로드해 주세요. jpeg, jpg, gif, png, pdf 파일만 가능하며 5MB이하의 파일만 업로드 가능합니다.');
          break;
        case 'KR':
        default:
          text = $i18next.t('account_request::사업자 등록증을 업로드해 주세요. jpeg, jpg, gif, png, pdf 파일만 가능하며 5MB이하의 파일만 업로드 가능합니다.');
          break;
      }
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: text,
        animation: false
      });
    }
    var TW_CERTIFICATION_VALIDATION_REGEX = /(^[0-9]{8}$)/;
    if (payload.business_location === 'TW' && (payload.certification.length > 8 || !TW_CERTIFICATION_VALIDATION_REGEX.test(payload.certification))) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::잘못된 납세자 번호입니다. 납세자 번호는 8자리 숫자만 입력 할 수 있습니다.'),
        animation: false
      });
    }
    if (payload.campaign_country === '') {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::광고를 게재할 나라를 선택해 주세요.'),
        animation: false
      });
    }
    if (payload.campaign_type === '') {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::캠페인의 비즈니스 타입을 선택해 주세요.'),
        animation: false
      });
    }
    if (payload.budget_info === '') {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::광고 예산 정보를 선택해 주세요.'),
        animation: false
      });
    }
    if (payload.campaign_info === '') {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::광고 집행일정을 선택해 주세요.'),
        animation: false
      });
    }
    if (payload.sample_url.length === 0) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::샘플 콘텐츠 URL을 선택해 주세요.'),
        animation: false
      });
    }
    if (!payload.is_agree) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('inquiry::개인정보 수집 및 이용 안내에 동의해주세요'),
        animation: false
      });
    }
    if (payload.campaign_country === 'VN' && payload.campaign_type === CAMPAIGN_TYPES.TYPE3 && !payload.product_license) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::제품 라이센스를 업로드해 주세요.'),
        animation: false
      });
    }

    // 비밀번호 유효성 검사 추가
    var hasLetter = /[a-zA-Z]/.test(payload.pwd);
    var hasNumber = /[0-9]/.test(payload.pwd);
    var specialChars = '!"#$%&\'()*+,-./:;<=>?@[₩\\]^_`{|}~';
    var hasSpecial = new RegExp("[".concat(specialChars.replace(/[[\]\\^$.*+?(){}|]/g, '\\$&'), "]")).test(payload.pwd);
    if (!hasLetter || !hasNumber || !hasSpecial || payload.pwd.length < 8) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::비밀번호 형식이 올바르지 않습니다.'),
        animation: false
      });
    }
    $http.post('/api/account_request', payload).success(function (result) {
      init();
      if (result.message === 'OK') {
        executeMSNConversionScript($window.LANG);
        sendMessageToParentWindow(MESSAGE_TYPE.SUBMIT_FORM, {
          type: MESSAGE_TYPE.SUBMIT_FORM
        });
        return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
          type: 'info',
          title: '',
          text: $i18next.t('account_request::계정 생성 요청이 신청되었습니다.'),
          animation: false
        });
      } else {
        return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
          type: 'info',
          title: '',
          text: $i18next.t('account_request::계정 생성 요청이 실패하였습니다.'),
          animation: false
        });
      }
    })["catch"](function (err) {
      return handleRequestError(err);
    });
  };
  var changePlaceHolder = function changePlaceHolder() {
    if ($scope.payload.type === 'client') {
      $scope.placeholder.biz_name = $i18next.t('account_request::회사명을 입력해 주세요.');
      $scope.placeholder.biz_url = $i18next.t('account_request::회사 웹사이트 주소를 입력해 주세요. (optional)');
      $scope.placeholder.biz_sample_url = $i18next.t('account_request::광고 캠페인에 사용하실 샘플 콘텐츠 url을 입력해 주세요.');
    } else {
      $scope.placeholder.biz_name = $i18next.t('account_request::(대행사) 회사명을 입력해 주세요.');
      $scope.placeholder.biz_url = $i18next.t('account_request::(대행사) 회사 웹사이트 주소를 입력해 주세요. (optional)');
      $scope.placeholder.biz_sample_url = $i18next.t('account_request::(대행사) 광고 캠페인에 사용하실 샘플 콘텐츠 url을 입력해 주세요.');
    }
  };
  var upload = function upload(_ref) {
    var element = _ref.element,
      upload_api_path = _ref.upload_api_path,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError;
    var image = element.files.length === 1 ? element.files[0] : null;
    if (!image) return null;
    var formData = new FormData();
    var APPROVAL_EXTENSION = ['jpeg', 'jpg', 'png', 'gif', 'pdf'];
    var image_extension = image.name.split('.').pop().toLowerCase();
    if (APPROVAL_EXTENSION.indexOf(image_extension) === -1) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t("account_request::잘못된 파일입니다. '.jpeg', '.jpg', '.png', '.gif', '.pdf' 확장자를 가진 파일만 가능합니다."),
        animation: false
      });
    }
    if (image === null || image.size === 0) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::잘못된 파일입니다. 파일을 확인해 주세요.'),
        animation: false
      });
    }
    if (image.size >= 1024 * 1024 * 5) {
      return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
        type: 'info',
        title: '',
        text: $i18next.t('account_request::파일이 5MB를 넘습니다. 더 작은 파일을 사용해주세요.'),
        animation: false
      });
    }
    formData.append('file', image);
    return $http.post(upload_api_path, formData, {
      transformRequest: angular.identity,
      headers: {
        'Content-Type': undefined
      }
    }).success(onSuccess).error(onError);
  };
  var uploadCertification = function uploadCertification(element) {
    upload({
      element: element,
      upload_api_path: '/api/account_request/certification',
      onSuccess: function onSuccess(res) {
        var data = res.data;
        if (data && data.message === 'OK') {
          $scope.payload.certification = data.url;
        } else {
          return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
            type: 'info',
            title: '',
            text: $i18next.t('account_request::사업자 등록증 업로드에 실패하였습니다.'),
            animation: false
          });
        }
      },
      onError: function onError() {
        return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
          type: 'info',
          title: '',
          text: $i18next.t('account_request::사업자 등록증 업로드에 실패하였습니다.'),
          animation: false
        });
      }
    });
  };
  var uploadProductLicense = function uploadProductLicense(element) {
    upload({
      element: element,
      upload_api_path: '/api/account_request/product_license',
      onSuccess: function onSuccess(res) {
        var data = res.data;
        if (data && data.message === 'OK') {
          $scope.payload.product_license = data.url;
        } else {
          return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
            type: 'info',
            title: '',
            text: $i18next.t('account_request::제품 라이센스 업로드에 실패하였습니다.'),
            animation: false
          });
        }
      },
      onError: function onError() {
        return sendMessageToParentWindow(MESSAGE_TYPE.ALERT, {
          type: 'info',
          title: '',
          text: $i18next.t('account_request::제품 라이센스 업로드에 실패하였습니다.'),
          animation: false
        });
      }
    });
  };
  var changeBudgetOptions = function changeBudgetOptions(business_location) {
    $scope.budget_option = {
      '': "".concat($i18next.t('account_request::월 광고 예산 정보를 공유해 주세요.'))
    };
    switch (business_location) {
      case 'JP':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 100,000 JPY', '100,000 JPY - 500,000 JPY', '500,000 JPY - 1,000,000 JPY', 'Over 1,000,000 JPY']));
        break;
      case 'ID':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 10,000,000 IDR', '10,000,000 IDR - 50,000,000 IDR', '50,000,000 IDR - 100,000,000 IDR', 'Over 100,000,000 IDR']));
        break;
      case 'TW':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 50,000 TWD', '50,000 TWD - 100,000 TWD', '100,000 TWD - 200,000 TWD', 'Over 200,000 TWD']));
        break;
      case 'VN':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 20,000,000 VND', '20,000,000 VND - 60,000,000 VND', '60,000,000 VND - 100,000,000 VND', 'Over 100,000,000 VND']));
        break;
      case 'MY':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 5,000 MYR', '5,000 - 10,000 MYR', '10,000 - 15,000 MYR', 'Over 15,000 MYR']));
        break;
      case 'KR':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['300만원 이하', '300만원 - 1000만원', '1000만원 - 3000만원', '3000만원 이상']));
        break;
      case 'HK':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 5,000 HKD', '5,000 - 20,000 HKD', '20,000 - 50,000 HKD', 'Over 50,000 HKD']));
        break;
      case 'SG':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 1,000 SGD', '1,000 SGD - 5,000 SGD', '5,000 SGD - 10,000 SGD', 'Over 10,000 SGD']));
        break;
      case 'TH':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 50,000 THB', '50,000 THB - 100,000 THB', '100,000 THB - 200,000 THB', 'Over 200,000 THB']));
        break;
      case 'AU':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 1,000 AUD', '1,000 AUD - 5,000 AUD', '5,000 AUD - 10,000 AUD', 'Over 10,000 AUD']));
        break;
      case 'CN':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 5,000 CNY', '5,000 CNY - 20,000 CNY', '20,000 CNY - 50,000 CNY', 'Over 50,000 CNY']));
        break;
      case 'NZ':
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 1,000 NZD', '1,000 AUD - 5,000 NZD', '5,000 AUD - 10,000 NZD', 'Over 10,000 NZD']));
        break;
      case 'ETC':
      default:
        $scope.budget_option = _.merge($scope.budget_option, keyMirror(['Under 3,000 USD', '3,000 USD - 10,000 USD', '10,000 USD - 30,000 USD', 'Over 30,000 USD']));
        break;
    }
  };
  var togglePassword = function togglePassword() {
    $scope.showPassword = !$scope.showPassword;
  };
  var isEmptyEmail = function isEmptyEmail(email) {
    return email === null || email === undefined || email.trim() === '';
  };
  var isValidEmail = function isValidEmail(email) {
    var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z]+$/;
    return emailRegex.test(email);
  };
  $scope.$watch('payload.business_location', function (business_location) {
    changeBudgetOptions(business_location);
    setTimeout(function () {
      syncHeight();
    }, 0);
  });
  $scope.$watch('payload.campaign_type', function () {
    $scope.payload.product_license = '';
  });
  $scope.inflow_options = _.concat([{
    value: '',
    label: $i18next.t('account_request::데이블을 어떻게 알게 되셨나요?')
  }], _.map(INFLOW_TYPES, function (type) {
    return {
      value: type,
      label: $i18next.t("inquiry::".concat(type))
    };
  }));
  $scope.CAMPAIGN_TYPES = CAMPAIGN_TYPES;
  $scope.campaign_type_options = _.concat([{
    value: '',
    label: $i18next.t('account_request::광고 캠페인의 비즈니스 타입을 선택해 주세요.')
  }], _.map(CAMPAIGN_TYPES, function (type) {
    return {
      value: type,
      label: $i18next.t("account_request::".concat(type))
    };
  }));
  $scope.placeholder = {
    biz_name: $i18next.t('account_request::회사명을 입력해 주세요.'),
    biz_url: $i18next.t('account_request::회사 웹사이트 주소를 입력해 주세요. (optional)'),
    biz_sample_url: $i18next.t('account_request::광고 캠페인에 사용하실 샘플 콘텐츠 url을 입력해 주세요.')
  };
  $scope.validateEmailOnChange = function ($event) {
    $scope.emailValidation.error = null;
    if ($event) {
      $scope.emailValidation.store = $event.target.value;
    }
  };
  $scope.validateEmailOnBlur = function () {
    var email = $scope.payload.email || $scope.emailValidation.store;
    if (isEmptyEmail(email)) {
      $scope.emailValidation.error = $i18next.t('account_request::이메일을 입력해 주세요.');
    } else if (!isValidEmail(email)) {
      $scope.emailValidation.error = $i18next.t('account_request::이메일 주소 형식이 올바르지 않습니다. 다시 확인해 주세요.');
    } else {
      $scope.emailValidation.error = null;
    }
  };

  // 비밀번호 실시간 유효성 검사
  $scope.validatePasswordOnChange = function ($event) {
    $scope.passwordValidation.error = null;
    if ($event) {
      $scope.passwordValidation.store = $event.target.value;
    }
    var password = $scope.payload.pwd || $scope.passwordValidation.store;

    // 8자 이상 체크
    $scope.passwordValidation.isLengthValid = password.length >= 8;

    // 영문, 숫자, 특수문자 조합 체크
    var hasLetter = /[a-zA-Z]/.test(password);
    var hasNumber = /[0-9]/.test(password);
    var specialChars = '!"#$%&\'()*+,-./:;<=>?@[₩\\]^_`{|}~';
    var hasSpecial = new RegExp("[".concat(specialChars.replace(/[[\]\\^$.*+?(){}|]/g, '\\$&'), "]")).test(password);
    $scope.passwordValidation.isComplexityValid = hasLetter && hasNumber && hasSpecial;
  };

  // 비밀번호 입력창 blur 시 유효성 검사
  $scope.validatePasswordOnBlur = function () {
    var password = $scope.payload.pwd || $scope.passwordValidation.store;
    if (password) {
      if (!$scope.passwordValidation.isLengthValid || !$scope.passwordValidation.isComplexityValid) {
        $scope.passwordValidation.error = $i18next.t('account_request::영문, 숫자, 특수문자를 조합하여 8자리 이상을 입력해 주세요.');
      } else {
        $scope.passwordValidation.error = null;
      }

      // 이메일 주소에서 이름과 도메인 추출
      if ($scope.payload.email) {
        var emailParts = $scope.payload.email.split('@');
        if (emailParts.length === 2) {
          var _emailParts = (0, _slicedToArray2["default"])(emailParts, 2),
            emailName = _emailParts[0],
            domainPart = _emailParts[1];
          var emailDomain = domainPart ? domainPart.split('.')[0] : '';

          // 비밀번호에 이메일 이름이나 도메인이 포함되어 있는지 확인
          if ($scope.payload.pwd.toLowerCase().includes(emailName.toLowerCase()) || $scope.payload.pwd.toLowerCase().includes(emailDomain.toLowerCase())) {
            $scope.passwordValidation.error = $i18next.t('account_request::이메일에 있는 단어는 비밀번호에 사용할 수 없습니다.');
          }
        }
      }
    }
  };
  $scope.submit = submit;
  $scope.changePlaceHolder = changePlaceHolder;
  $scope.uploadCertification = uploadCertification;
  $scope.uploadProductLicense = uploadProductLicense;
  $scope.showPassword = false;
  $scope.togglePassword = togglePassword;
  init();
}]);

},{"@babel/runtime/helpers/interopRequireDefault":4,"@babel/runtime/helpers/slicedToArray":7}],2:[function(require,module,exports){
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],3:[function(require,module,exports){
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],4:[function(require,module,exports){
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],5:[function(require,module,exports){
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],6:[function(require,module,exports){
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],7:[function(require,module,exports){
var arrayWithHoles = require("./arrayWithHoles.js");
var iterableToArrayLimit = require("./iterableToArrayLimit.js");
var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");
var nonIterableRest = require("./nonIterableRest.js");
function _slicedToArray(r, e) {
  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayWithHoles.js":3,"./iterableToArrayLimit.js":5,"./nonIterableRest.js":6,"./unsupportedIterableToArray.js":8}],8:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray.js");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":2}]},{},[1]);
